export function professorSchedule() {
  return `{
professorSchedule {
    color,
    begin,
    end,
    subject {
        id
        name
        label
        value
    },
    room {
        id
        name
    },
    schoolClass {
        id
        name
        label
        value
        academicCalendar { id }
        classShift {
            id
            name
            label
            value
        }
        courseStep {
            id
            fullName
            label
            value
            cycleQuantity
            course { 
              id 
              name 
              name
              label
            }
        }
    }
    classSequence
    professor {
      id
      name
      label
      value
    }
  }
}`;
}

export function professorScheduleForClassDiary(
  classId,
  shiftId,
  professorId = 0
) {
  return `{
    professorScheduleForClassDiary (schoolClassId: ${classId}, professorId: ${professorId}, shiftId: ${shiftId}) {
        subject {
            id
            name
            label
            value
        }
        schoolClass {
            id
        }
        classSequence    
      }
    }`;
}

export function professorScheduleByDateAndId(date, professorId) {
  return `{
  professorScheduleByDateAndId(dateInMilli: ${date.getTime()}, professorId: ${professorId}) {
    begin
    schoolClass {
      id
      name
    }
    subject {
      id 
      name
      label
      value
    }
    classSequence
  }
}`;
}

export function professorScheduleGridByDateAndId(date, professorId) {
  return `{
 professorScheduleByDateAndId(dateInMilli: ${
   date ? date.getTime() : new Date().getTime()
 } , professorId: ${professorId}) 
 {
    color,
    begin,
    end,
    subject {
        id
        name
        label
        value
    },
    room {
        id
        name
    },
    schoolClass {
        id
        name
        label
        value
        academicCalendar { id }
        classShift {
            id
            name
            label
            value
        }
        courseStep {
            id
            fullName
            label
            value
            cycleQuantity
            course { 
              id 
              name 
              name
              label
            }
        }
    },
    summary {
      occurrence
      exam
      diary
    }
    classSequence
    professor {
      id
      name
      label
      value
    }
  }
}`;
}

export function professorScheduleDisabledDates(schoolClassId, subjectId) {
  const query = `
    {
      professorScheduleDisabledDates (schoolClassId: ${schoolClassId}, subjectId: ${subjectId})
    }    
  `;
  return query;
}

export function professorScheduleAvailableClasses(
  schoolClassId,
  subjectId,
  selectedDate,
  professorId = 0
) {
  const query = `
    {
      professorScheduleAvailableClasses (schoolClassId: ${schoolClassId}, subjectId: ${subjectId}, selectedDateInMilli: ${selectedDate.getTime()}, professorId: ${professorId})
    }    
  `;
  return query;
}
